<div class="editor" [class.is-disabled]="isDisabled">

    <!-- ═══════════ Toolbar ═══════════ -->
    <!-- mousedown is prevented on every control so the caret / selection in the surface survives
         the click and the command applies to the text the author highlighted. -->
    <div class="editor-toolbar">

        @for (group of TOOL_GROUPS; track $index) {

        @if (!$first) {
        <span class="tool-divider"></span>
        }

        @for (tool of group; track tool.command) {
        <button type="button" class="tool" [class.is-on]="activeCommands[tool.command]"
            [attr.aria-label]="tool.label" [attr.aria-pressed]="tool.stateful ? !!activeCommands[tool.command] : null"
            [matTooltip]="tool.label" [disabled]="isDisabled" (mousedown)="$event.preventDefault()"
            (click)="runCommand(tool.command)">
            <mat-icon>{{ tool.icon }}</mat-icon>
        </button>
        }

        }

        <span class="tool-divider"></span>

        <!-- Native colour input, styled as a swatch button — no picker dependency needed. -->
        <label class="tool tool-color" matTooltip="Text colour">
            <mat-icon>format_color_text</mat-icon>
            <input type="color" class="color-input" [disabled]="isDisabled"
                (mousedown)="$event.stopPropagation()" (change)="applyTextColor($event)" />
        </label>

        <button type="button" class="tool" aria-label="Insert link" matTooltip="Insert link"
            [class.is-on]="linkBarOpen" [disabled]="isDisabled" (mousedown)="$event.preventDefault()"
            (click)="openLinkBar()">
            <mat-icon>link</mat-icon>
        </button>
    </div>

    <!-- ═══════════ Link bar ═══════════ -->
    @if (linkBarOpen) {
    <div class="link-bar">
        <input type="url" class="link-input" placeholder="example.com/page" [(ngModel)]="linkUrl"
            (keydown.enter)="applyLink()" (keydown.escape)="closeLinkBar()" />
        <button type="button" class="link-apply" (click)="applyLink()">Apply</button>
        <button type="button" class="link-cancel" aria-label="Cancel" (click)="closeLinkBar()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    }

    <!-- ═══════════ Editing surface ═══════════ -->
    <div #surface class="editor-surface" role="textbox" aria-multiline="true"
        [attr.contenteditable]="!isDisabled" [attr.data-placeholder]="placeholder()"
        [class.is-empty]="isEmpty" (input)="onInput()" (blur)="onBlur()" (paste)="onPaste($event)"
        (keyup)="refreshToolbarState()" (mouseup)="refreshToolbarState()"
        (focus)="refreshToolbarState()"></div>

</div>
